import { ref } from "vue";

const ASSISTANT_ID_PARAM = "aid";
const SETTINGS_ID_PARAM = "sid";

const assistantId = ref();
const settingsId = ref();

export const useGlobalConfig = () => {
  const storeAssistantId = () => {
    console.log(getQueryStringParam(ASSISTANT_ID_PARAM));
    // Get the assistant id from the query parameter
    assistantId.value =
      getScriptParam(ASSISTANT_ID_PARAM) ||
      getQueryStringParam(ASSISTANT_ID_PARAM) ||
      import.meta.env.VITE_ASSISTANT_ID;
  };

  const storeSettingsId = () => {
    // Get the settings id from the query parameter
    settingsId.value =
      getScriptParam(SETTINGS_ID_PARAM) ||
      getQueryStringParam(ASSISTANT_ID_PARAM) ||
      import.meta.env.VITE_SETTINGS_ID;
  };

  return {
    ASSISTANT_ID_PARAM,
    SETTINGS_ID_PARAM,
    assistantId,
    settingsId,
    storeAssistantId,
    storeSettingsId,
  };
};
